// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"t4-z","dimensionLabel":"u4-z","styleChooserControlWrapper":"v4-z","styleChooserControl":"w4-z","disabled":"x4-z","giftCard":"y4-z","styleChooserText":"z4-z"};